import { Loader } from 'kiswe-ui'
import Convertable from '@/classes/Convertable'

export default class ActiveState extends Convertable {
  idle: boolean = true
  isActive: boolean = true
  isLinkShared: boolean = false
  isOpen: boolean = false
  lastEntered: Date|null = null
  linked: number = 0

  constructor (data: Partial<ActiveState> = {}) {
    super(data)
    this.idle = Loader.loadBoolean(data, 'idle', this.idle)
    this.isActive = Loader.loadBoolean(data, 'isActive', this.isActive)
    this.isLinkShared = Loader.loadBoolean(data, 'isLinkShared', this.isLinkShared)
    this.isOpen = Loader.loadBoolean(data, 'isOpen', this.isOpen)
    this.lastEntered = Loader.loadDateOrNull(data, 'lastEntered', this.lastEntered)
    this.linked = Loader.loadNumber(data, 'linked', this.linked)
  }
}
